import { useDispatchModal } from '@libs/ui/ds/lib/internals/contexts/globalModalContext/hooks/useDispatchModal'
import type { ReactNode } from 'react'
import { useCallback, useMemo } from 'react'

import type { ModalProps } from '../../base/Modal.types'

export const GLOBAL_APP_SIMPLE_MODAL = 'GLOBAL_APP_SIMPLE_MODAL'

type SimpleModalProps = Pick<ModalProps, 'variant' | 'size' | 'height'>

export type OpenSimpleModalProps = {
  content: ReactNode
  props?: SimpleModalProps
}

/**
 * Expose disclosure context
 */
export function useSimpleModal() {
  const ctx = useDispatchModal({
    name: GLOBAL_APP_SIMPLE_MODAL
  })

  if (!ctx) {
    throw new Error(
      'ModalDispatch.Context is used outside of ModalDispatch.Provider'
    )
  }

  /**
   * Reset data from the modal context and the search params url
   */
  const handleOpen = useCallback(
    ({ content, props }: OpenSimpleModalProps) => {
      return ctx.open({ props, content })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctx.open]
  )

  return useMemo(
    () => ({
      open: handleOpen,
      close: ctx.close
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ctx.open]
  )
}
